"use client";

import { SupportSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedSupportSection from "../Components/GeneratedSupportSection";

const Support: FC<SupportSectionProps> = (props) => {
  return <GeneratedSupportSection {...props} />;
};

export default Support;
